import {
  Injectable
} from '@angular/core';


import {BehaviorSubject} from 'rxjs';
import {ApiService} from '../api';
import {UserContext} from '../user-context';
import {HttpParams} from '@angular/common/http';
import {UserInfo} from '../../models';

@Injectable()

export class LocationSummaryService {

  locationSummary: any[];

  locationObserver: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor( private api: ApiService,
               private userContext: UserContext
  ) {
    this.locationObserver.subscribe((change: boolean) => {
      // console.log('Checking account for ' + change + ' ' + (this.userContext.user.account_id || (this.userContext.account || {}).id));
      if ( change && (this.userContext.account || this.userContext.user.account_id )) {
        const params = new HttpParams()
          .set('summary', 'true')
          .set('account', this.userContext.user.account_id || this.userContext.account.id);

        console.log('Getting locations for ' + (this.userContext.user.account_id || this.userContext.account.id));
        this.api.get<any>(`/account/${this.userContext.user.account_id || this.userContext.account.id}/location`, params)
          .subscribe(locations => {
            if (locations) {
              //console.log('Received location summary: ' + JSON.stringify(locations));
              this.locationSummary = locations;
            }
          });
      }
    });

  }

  public clear(): void {
    this.locationSummary = null;
  }
}
